// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_FoldableWithIndex from "../Data.FoldableWithIndex/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Functor_Compose from "../Data.Functor.Compose/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_LogicExpr_AST from "../Data.LogicExpr.AST/index.js";
import * as Data_LogicExpr_NormalForm from "../Data.LogicExpr.NormalForm/index.js";
import * as Data_LogicExpr_Parser from "../Data.LogicExpr.Parser/index.js";
import * as Data_LogicExpr_ToB4Expr from "../Data.LogicExpr.ToB4Expr/index.js";
import * as Data_LogicValues_B4 from "../Data.LogicValues.B4/index.js";
import * as Data_LogicValues_ToB4 from "../Data.LogicValues.ToB4/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid_Conj from "../Data.Monoid.Conj/index.js";
import * as Data_Monoid_Disj from "../Data.Monoid.Disj/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Render from "../Data.Render/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Effect_Exception from "../Effect.Exception/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Parsing from "../Parsing/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var toB4ExprValueExpr = /* #__PURE__ */ Data_LogicExpr_ToB4Expr.toB4ExprValueExpr(Data_LogicValues_ToB4.toB4B4);
var toB4Expr = /* #__PURE__ */ Data_LogicExpr_ToB4Expr.toB4Expr(/* #__PURE__ */ Data_LogicExpr_ToB4Expr.toB4ExprCompose(/* #__PURE__ */ Data_LogicExpr_ToB4Expr.toB4ExprEither(Data_LogicValues_ToB4.toB4ParseError))(toB4ExprValueExpr));
var bindB4Terms = /* #__PURE__ */ Data_LogicExpr_ToB4Expr.bindB4Terms(toB4ExprValueExpr)(toB4ExprValueExpr);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var heytingAlgebraValueExpr = /* #__PURE__ */ Data_LogicExpr_AST.heytingAlgebraValueExpr(Data_LogicValues_B4.heytingAlgebraB4);
var foldMap = /* #__PURE__ */ Data_Foldable.foldMap(Data_Foldable.foldableArray);
var trimClassical$prime = /* #__PURE__ */ Data_LogicExpr_ToB4Expr["trimClassical$prime"](toB4ExprValueExpr);
var ordEither = /* #__PURE__ */ Data_Either.ordEither(Data_LogicValues_B4["ordB4$prime"])(Data_Ord.ordString);
var toDNF = /* #__PURE__ */ Data_LogicExpr_NormalForm.toDNF(ordEither);
var toCNF = /* #__PURE__ */ Data_LogicExpr_NormalForm.toCNF(ordEither);
var rightOrFail = function (dictMonadThrow) {
    var throwError = Control_Monad_Error_Class.throwError(dictMonadThrow);
    var pure = Control_Applicative.pure((dictMonadThrow.Monad0()).Applicative0());
    return function (dictShow) {
        var show = Data_Show.show(dictShow);
        return function (v) {
            if (v instanceof Data_Either.Left) {
                return throwError(Effect_Exception.error(show(v.value0)));
            };
            if (v instanceof Data_Either.Right) {
                return pure(v.value0);
            };
            throw new Error("Failed pattern match at Public.Expr (line 147, column 1 - line 147, column 79): " + [ v.constructor.name ]);
        };
    };
};
var rightOrFail1 = /* #__PURE__ */ rightOrFail(Control_Monad_Error_Class.monadThrowEffect)(Parsing.showParseError);
var nfClauseToPublic = /* #__PURE__ */ (function () {
    var f = function (v) {
        return function (v1) {
            if (v instanceof Data_Either.Left && v.value0 instanceof Data_LogicValues_B4["Undecidable$prime"]) {
                return Foreign_Object.insert("UNDECIDABLE")(true);
            };
            if (v instanceof Data_Either.Left && v.value0 instanceof Data_LogicValues_B4["Indeterminate$prime"]) {
                return Foreign_Object.insert("INDETERMINATE")(true);
            };
            if (v instanceof Data_Either.Right) {
                return Foreign_Object.insert(v.value0)(v1);
            };
            throw new Error("Failed pattern match at Public.Expr (line 157, column 9 - line 157, column 69): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
    return Data_FoldableWithIndex.foldrWithIndex(Data_Map_Internal.foldableWithIndexMap)(f)(Foreign_Object.empty);
})();
var toPublicNormalForm = /* #__PURE__ */ (function () {
    var $68 = map(nfClauseToPublic);
    var $69 = Data_Array.fromFoldable(Data_List_Types.foldableList);
    return function ($70) {
        return $68($69($70));
    };
})();
var lookupFromObj = function (obj) {
    return function (term) {
        return map1(function ($71) {
            return toB4Expr(Data_Functor_Compose.Compose(Data_LogicExpr_Parser["parseExpression$prime"]($71)));
        })(Foreign_Object.lookup(term)(obj));
    };
};
var bindTermsOf$prime = function (expr) {
    return function (obj) {
        return bindB4Terms(lookupFromObj(obj))(expr);
    };
};
var _yes = /* #__PURE__ */ (function () {
    return Data_LogicExpr_AST.value(Data_LogicValues_B4.Yes.value);
})();
var _undecidable = /* #__PURE__ */ (function () {
    return Data_LogicExpr_AST.value(Data_LogicValues_B4.Undecidable.value);
})();
var _toString = /* #__PURE__ */ Data_Render.render(/* #__PURE__ */ Data_Render.renderValueExpr(Data_Render.renderB4)(Data_Render.renderString));
var _pure = /* #__PURE__ */ Control_Applicative.pure(Data_LogicExpr_AST.applicativeValueExpr);
var _precedence = function ($72) {
    return Data_LogicExpr_AST.precedence(unwrap($72));
};
var _parseString = function (expr) {
    return rightOrFail1(Data_LogicExpr_Parser["parseExpression$prime"](expr));
};
var _not = /* #__PURE__ */ Data_HeytingAlgebra.not(heytingAlgebraValueExpr);
var _nodeType = function ($73) {
    return Data_LogicExpr_AST.nodeType(unwrap($73));
};
var _no = /* #__PURE__ */ (function () {
    return Data_LogicExpr_AST.value(Data_LogicValues_B4.No.value);
})();
var _isValue = Data_LogicExpr_AST.isValue;
var _isTerm = Data_LogicExpr_AST.isTerm;
var _indeterminate = /* #__PURE__ */ (function () {
    return Data_LogicExpr_AST.value(Data_LogicValues_B4.Indeterminate.value);
})();
var _implies = /* #__PURE__ */ Data_HeytingAlgebra.implies(heytingAlgebraValueExpr);
var _freeTerms = /* #__PURE__ */ Data_LogicExpr_AST.freeTerms(Data_Ord.ordString);
var _foldDisj = /* #__PURE__ */ (function () {
    var $74 = foldMap(Data_Monoid_Disj.monoidDisj(heytingAlgebraValueExpr))(Data_Monoid_Disj.Disj);
    return function ($75) {
        return unwrap($74($75));
    };
})();
var _foldConj = /* #__PURE__ */ (function () {
    var $76 = foldMap(Data_Monoid_Conj.monoidConj(heytingAlgebraValueExpr))(Data_Monoid_Conj.Conj);
    return function ($77) {
        return unwrap($76($77));
    };
})();
var _evaluate = function ($78) {
    return Data_LogicValues_B4.graphqlRep(Data_LogicExpr_ToB4Expr.evaluateB4($78));
};
var _equiv = /* #__PURE__ */ Data_LogicExpr_AST.equiv(/* #__PURE__ */ Data_LogicExpr_AST.equivValueExpr(Data_LogicExpr_AST.equivB4));
var _elimClassicalValues = /* #__PURE__ */ Data_LogicExpr_ToB4Expr.trimClassical(toB4ExprValueExpr);
var _dnf = function ($79) {
    return (function (v) {
        if (v instanceof Data_Either.Left && v.value0) {
            return [ Foreign_Object.empty ];
        };
        if (v instanceof Data_Either.Left && !v.value0) {
            return [  ];
        };
        if (v instanceof Data_Either.Right) {
            return toPublicNormalForm(unwrap(toDNF(unwrap(v.value0))));
        };
        throw new Error("Failed pattern match at Public.Expr (line 136, column 27 - line 139, column 68): " + [ v.constructor.name ]);
    })(trimClassical$prime($79));
};
var _disj = /* #__PURE__ */ Data_HeytingAlgebra.disj(heytingAlgebraValueExpr);
var _conj = /* #__PURE__ */ Data_HeytingAlgebra.conj(heytingAlgebraValueExpr);
var _cnf = function ($80) {
    return (function (v) {
        if (v instanceof Data_Either.Left && v.value0) {
            return [  ];
        };
        if (v instanceof Data_Either.Left && !v.value0) {
            return [ Foreign_Object.empty ];
        };
        if (v instanceof Data_Either.Right) {
            return toPublicNormalForm(unwrap(toCNF(unwrap(v.value0))));
        };
        throw new Error("Failed pattern match at Public.Expr (line 130, column 27 - line 133, column 68): " + [ v.constructor.name ]);
    })(trimClassical$prime($80));
};
var _children = /* #__PURE__ */ (function () {
    var $81 = map(Data_Newtype.wrap());
    return function ($82) {
        return $81(Data_LogicExpr_AST.children(unwrap($82)));
    };
})();
var _bindTerms = bindTermsOf$prime;
var _bind = /* #__PURE__ */ Control_Bind.bind(Data_LogicExpr_AST.bindValueExpr);
export {
    _bind,
    _bindTerms,
    _children,
    _cnf,
    _conj,
    _disj,
    _dnf,
    _elimClassicalValues,
    _equiv,
    _evaluate,
    _foldConj,
    _foldDisj,
    _freeTerms,
    _implies,
    _indeterminate,
    _isTerm,
    _isValue,
    _no,
    _nodeType,
    _not,
    _parseString,
    _precedence,
    _pure,
    _toString,
    _undecidable,
    _yes
};
//# sourceMappingURL=index.js.map
